import React from "react";

import {
    Modal,
    ModalBody,
    FormGroup,
    ModalFooter,
    Button,
    Row, Col
} from "reactstrap";

import Request from '../../common/Request';

import InputText from '../FormParts/InputText';
import InputSelect from '../FormParts/InputSelect';
import WithRole from '../FormParts/ButtonWithRole';
import GsuiteAuth from '../../components/Auth/GsuiteAuth';
import { GetMessage, getErrorCodes } from '../../variables/message';
import InputRadio from '../FormParts/InputRadio'

export default class UserSelectPopup extends React.Component {
    constructor(props) {
        super(props);

        this.state = {
            modal: false,
            data: {
                values:{
                    // 調査ステータスは1:Web調査のみ
                    survey_estimate_status : 1
                },
                errors:{
                    id:[GetMessage(2024)],
                },
                requiredData:{
                    id:[GetMessage(2024)],
                }
            },
            userData:[],
        };

        this.toggleModal = this.toggleModal.bind(this)
        this.clickSelectButton = this.clickSelectButton.bind(this)
        this.validateCallBack = this.validateCallBack.bind(this)
    }

    componentDidMount(){
        const url = '/api/landmark/user';
        Request.get(url, {}, res => {
            this.setState({
                userData: res.Data,
                data : {
                    ...this.state.data,
                    values : {
                        ...this.state.data.values,
                        survey_report : this.props.requestData.survey_report
                    }
                }
            });
        })
    }

    validateCallBack(newData, callback=()=>{}){
        const data = this.state.data;
        this.setState({
          data:{
            ...data,
            ...newData
          }
        }, ()=>callback())
    }

    validate() {
        let message = getErrorCodes(this.state.data.errors)
        if(message.length > 0){
            this.props.alertModal.current.showErrorModal({messageNo:message});
            return false;
        }
        return true;
    }
    
    clickSelectButton() {
        const {
            data:{
                values,
            }
        } = this.state

        if(!this.validate()){
            return;
        }

        const user = this.state.userData.find((user)=>user.id==values.id)
        
        const url = '/api/request/' + this.props.requestData.ulid;
        const params = {
            ...this.props.requestData,
            // Web調査担当者
            web_survey_account : user.id,
            // 現地調査担当者(Web調査のみのため登録しないようundefined)
            onsite_survey_account : undefined,
            survey_report:values.survey_report,
            // 調査ステータス(1:Web調査)
            survey_status:1
        };
        Request.put(url, params,
        res => {
            if (res.Code==200){
                this.props.history.push('/survey');
            }
        })
        this.toggleModal();
    }

    show() {
        this.setState({ modal: true });
    }

    toggleModal() {
        this.setState({
            modal: !this.state.modal
        });
    }

    render() {
//        console.log('state', this.state)
        const ButtonWithRole = WithRole(Button, this.props.buttons, this.props.requestData)
        return (
            <Modal size="lg" isOpen={this.state.modal}>
                <div className="modal-header">
                    <button type="button" className="close" data-dismiss="modal" aria-label="Close" onClick={this.toggleModal}>
                        <i className="tim-icons icon-simple-remove"></i>
                    </button>
                    <h5 className="modal-title float-left">ランドマーク担当者選択</h5>
                </div>
                <ModalBody>
                    <Row>
                        <Col md="12">
                            <FormGroup>
                                <InputSelect 
                                    label="ユーザ"
                                    name="USER__id"
                                    options={this.state.userData.filter(user => GsuiteAuth.get('user_branch_id') == user.user_branch_id).map((user)=>{return{label:user.name,value:user.id}})}
                                    rootData={this.state.data}
                                    validateCallback={this.validateCallBack} 
                                    isSearchable={true}
                                    />
                            </FormGroup>
                        </Col>
                    </Row>
                    <Row>
                        <Col md="12">
                            <FormGroup>
                                <InputText 
                                    name="REQUEST__survey_report"
                                    label="引継メモ"
                                    validateCallback={this.validateCallBack}
                                    multiline={true}
                                    rootData={this.state.data}
                                    validateType='regist'
                                />
                            </FormGroup>
                        </Col>
                    </Row>
                </ModalBody>
                <ModalFooter>
                    <Button style={{margin: '0 auto'}} color="info" onClick={this.toggleModal}>
                    キャンセル
                    </Button>
                    <ButtonWithRole button_id="BTN_C1_02_01710" style={{margin: '0 auto'}} color="secondary" onClick={this.clickSelectButton}>
                    変更
                    </ButtonWithRole>
                </ModalFooter>
            </Modal>
        );
    }
}
